const PLATFORM_DOCUMENT_URL = '/Platform/Document';
export const MEWS_TERMS_AND_CONDITIONS_URL = `${PLATFORM_DOCUMENT_URL}/TermsAndConditions`;
export const HOSPITALITY_CLOUD_TERMS_AND_CONDITIONS_URL = `${PLATFORM_DOCUMENT_URL}/HospitalityCloudTermsAndConditions`;
export const MEWS_PRIVACY_POLICY_URL = `${PLATFORM_DOCUMENT_URL}/PrivacyPolicy`;
export const DATA_SECURITY_URL = `${PLATFORM_DOCUMENT_URL}/DataSecurity`;
export const GUESTS_TERMS_AND_CONDITIONS_URL = `${PLATFORM_DOCUMENT_URL}/GuestsTermsAndConditions`;
export const MEWS_CAPITAL_DISCLAIMER = `${PLATFORM_DOCUMENT_URL}/CapitalDisclaimer`;
